module.exports = __webpack_public_path__ + "img/courseModule.1c8e7d8c.png";